{
  "version": 1,
  "asset_id": "0e069a29-08b0-4191-8a12-fba08fa981c8",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0e069a29-08b0-4191-8a12-fba08fa981c8/svc-content-strategy-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0e069a29-08b0-4191-8a12-fba08fa981c8/svc-content-strategy-640.webp",
  "original_filename": "svc-content-strategy-640.webp",
  "size": 10074,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:42Z"
}
